module.exports = __webpack_public_path__ + "media/images/icons/schedule-9dcd80891a817687d441f9064c6f09c9.svg";